import { EffortContactItem } from 'library/types';
import { renderAutoCompleteLocaleText } from 'utils';
import { gray } from 'providers/theme/themePrimitives';
import { Autocomplete, svgIconClasses, TextField, useTheme } from '@mui/material';

type AutocompleteMultiByIdProps = {
  options: EffortContactItem[];
  valueOptions: EffortContactItem[];
  onChangeOptions: (opts: EffortContactItem[]) => void;
  errorText?: string;
};

const AutocompleteMultiById = ({ options, valueOptions, onChangeOptions, errorText }: AutocompleteMultiByIdProps) => {
  const theme = useTheme();

  return (
    <Autocomplete
      size="small"
      multiple
      options={options}
      value={valueOptions}
      filterSelectedOptions
      disableCloseOnSelect
      {...renderAutoCompleteLocaleText()}
      isOptionEqualToValue={(opt, val) => opt.id === val.id}
      getOptionLabel={(opt) => opt.title}
      onChange={(_, newValue) => onChangeOptions(newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{
            '& .MuiButtonBase-root': {
              border: 'none',
              width: 'fit-content',
              height: '2.25rem',
              padding: '0.25rem',
              [`& .${svgIconClasses.root}`]: { fontSize: '1rem' },
              '&:hover': {
                backgroundColor: theme.palette.mode === 'light' ? gray[100] : gray[800],
              },
            },
            '& .MuiInputBase-root': {
              height: 'auto',
            },
          }}
          error={!!errorText}
          helperText={errorText}
        />
      )}
    />
  );
};

export default AutocompleteMultiById;
